module.exports = __webpack_public_path__ + "img/entrance-card.a353ef87.png";